import {NavigationItem} from "../../../utils/helpers/acl/getNavigationFromRole";
// import {agents} from "../../../config/acl/routes/all/common/agents";
import {price} from "../../../config/acl/routes/all/common/price";
import {airportData} from "../../../config/acl/routes/all/common/airportData";

export const headerSharedLinks: NavigationItem[] = [
  // {path: agents.path, title: agents.title},
  {path: price.path, title: price.title},
  {path: airportData.path, title: airportData.title},
]